import React from 'react'
import Link from 'next/link'
import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'
import { Separator } from '@wartek-id/separator'
import { Button } from '@wartek-id/button-v1'

import ForbiddenPage from '../components/ForbiddenPage'
import PeriodGuard from '../components/PeriodGuard'
import SpinnerLoading from '../components/SpinnerLoading'
import { useUserGroupSjt } from 'utils/hooks/useUserGroup'
import LoadingState from 'app/PemetaanKompetensiPage/components/LoadingState'
import { useMediaQueryHelper } from '../hooks/useMediaQueryHelper'
import PageBreadcrumb from '../components/PageBreadcrumb'
import { useApiUserDetailProfile } from 'api/competency-mapping/useAPIUserDetail'

const fieldsMappingLabel = {
  name: 'Nama',
  nip: 'NIP',
  educationUnitName: 'Satuan Pendidikan',
}

const ProfileConfirmation = ({ currentDateTimeServer }) => {
  const { isDesktop } = useMediaQueryHelper()
  const { hasAccess: hasNecessaryRole, isLoading: isLoadingNecessaryRole } =
    useUserGroupSjt()
  const isUjikomWhitelisted = !isLoadingNecessaryRole && hasNecessaryRole

  const { data, isLoading, isSuccess } = useApiUserDetailProfile('SJT', {
    enabled: isUjikomWhitelisted,
  })

  // To be displayed only if the role is being validated
  if (isLoadingNecessaryRole)
    return <LoadingState title="Halaman sedang dimuat..." />

  if (!isUjikomWhitelisted) return <ForbiddenPage />

  const TextCoupled = ({
    beforeText,
    afterText,
    withSeparator = true,
  }: {
    beforeText: string
    afterText: string
    withSeparator?: boolean
  }) => (
    <>
      <div className="flex my-5">
        <Text>{beforeText}:&nbsp;</Text>
        <Text variant="body-bold">{afterText}</Text>
      </div>
      {withSeparator && <Separator className="!bg-gray-20" />}
    </>
  )

  const RenderUserData = () => (
    <>
      {!!data &&
        isSuccess &&
        Object.entries(fieldsMappingLabel).map((thisEntry, thisKey) => (
          <TextCoupled
            beforeText={thisEntry[1]}
            afterText={data.data[thisEntry[0]]}
            key={`dat_${thisKey}`}
            withSeparator={thisEntry[0] !== 'educationUnitName'}
          />
        ))}
    </>
  )

  return (
    <div
      className={clsx(
        'pt-4 pb-6 bg-gray-10 min-h-full flex flex-col max-w-ujikom m-auto',
        !isDesktop && 'justify-between'
      )}
    >
      <PeriodGuard
        fullPageLoading
        currentDateTimeServer={currentDateTimeServer}
      >
        <PageBreadcrumb currentPageIndex={0} className="mt-9" />
        <div className="bg-white rounded-lg mx-4 pt-4 pb-1 px-4 mb-5">
          <SpinnerLoading isLoading={isLoading} className="mb-4" />
          {isSuccess && (
            <Text variant="heading-sm" className="mb-2">
              Selamat datang, {data.data.name}
            </Text>
          )}
          <Text variant="body" className="!mb-[32px]">
            Pastikan data diri Anda sesuai. Jika tidak, klik tombol Data tidak
            sesuai dan ikuti arahannya, ya.
          </Text>
          <RenderUserData />
        </div>
        <div
          className={clsx('mx-4', isDesktop && 'flex flex-row-reverse gap-x-4')}
        >
          <Link href="/pemetaan-kompetensi/pakta-integritas" passHref>
            <Button
              color="black"
              size="lg"
              className={clsx(!isDesktop && 'mb-3')}
              fullWidth={!isDesktop}
            >
              Ya, data sesuai
            </Button>
          </Link>
          <Link href="/pemetaan-kompetensi/data-tidak-sesuai" passHref>
            <Button color="white" size="lg" fullWidth={!isDesktop}>
              Data tidak sesuai
            </Button>
          </Link>
        </div>
      </PeriodGuard>
    </div>
  )
}

export default ProfileConfirmation
